import { render, staticRenderFns } from "./huojiangDetail.vue?vue&type=template&id=162b12d7&scoped=true&"
import script from "./huojiangDetail.vue?vue&type=script&lang=js&"
export * from "./huojiangDetail.vue?vue&type=script&lang=js&"
import style0 from "./huojiangDetail.vue?vue&type=style&index=0&id=162b12d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162b12d7",
  null
  
)

export default component.exports